<template>
  <div class="main">
    <div class="mian-top">
      <div @click="back">
        <i class="el-icon-arrow-left"></i>
        返回
      </div>
    </div>
    <div class="mian-bottom">
      <!-- 升级 -->
      <div>
        <div>
          <div class="bottitle">当前版本</div>
          <div class="table">
            <div class="props">套餐类型</div>
            <div class="props">人数</div>
            <div class="props">条数</div>
            <div class="props">周期</div>
            <div class="props">剩余有效期</div>
          </div>
          <div class="tableitem">
            <div class="props">{{ currentinfo.packageName }}</div>
            <div class="props">
              {{ currentinfo.lowerLimit }}(含)-{{ currentinfo.upperLimit }}人
            </div>
            <div class="props">{{ currentinfo.num }}条</div>
            <div class="props">
              {{ upgradeinfo.beginTime.slice(0, 10) }}至{{
                upgradeinfo.endTime.slice(0, 10)
              }}
            </div>
            <div class="props">
              {{ calculateMonthsDifference(upgradeinfo.end) }}月
            </div>
          </div>
        </div>
        <div>
          <div class="bottitle">升级版本</div>
          <div class="table">
            <div class="props">套餐类型</div>
            <div class="props" style="margin-left: 10px">人数</div>
            <div class="props">条数</div>
            <div class="props">单价</div>
            <div class="props">数量</div>
            <div class="props">增加条数</div>
            <div class="props">补差价</div>
          </div>
          <div class="tableitem">
            <div class="props">
              <el-select
                v-model="packagename"
                placeholder="请选择"
                @change="packagechange"
              >
                <el-option
                  v-for="item in mergepackage"
                  :label="item[0].packageName"
                  :key="item.id"
                  :value="item[0].packageName"
                >
                </el-option>
              </el-select>
            </div>
            <div class="props" style="margin-left: 10px">
              <el-select
                v-model="person"
                placeholder="请选择"
                @change="personchange"
              >
                <el-option
                  v-for="item in checkpackage"
                  :label="`${item.lowerLimit}(含)-${item.upperLimit}人`"
                  :value="item.id"
                  :key="item.id"
                >
                </el-option>
              </el-select>
            </div>
            <div class="props">{{ packageinfo.num }}条</div>
            <div class="props">
              {{ packageinfo.price * packageinfo.preferentialPrice }}/年
            </div>
            <div class="props">1年</div>
            <div class="props">
              {{
                Math.ceil(
                  (packageinfo.num / 12) *
                    calculateMonthsDifference(upgradeinfo.end)
                )
              }}
            </div>
            <div class="props" style="color: #ea4f2c">
              ￥{{
                (
                  ((packageinfo.price * packageinfo.preferentialPrice) / 12) *
                  calculateMonthsDifference(upgradeinfo.end)
                ).toFixed(2)
              }}/年
            </div>
          </div>
        </div>
      </div>

      <!-- 支付方式 -->
      <!-- <div class="bottitle" style="margin-top:65px">请选择支付方式:</div>
      <div class="buymode">
        <div class="modeitem">
          <img src="@/assets/zfb.png" alt="">
          <div class="moderight">
            <div class="paytitle">
              支付宝 扫码支付
            </div>
            <div class="payinfo">使用支付宝支付</div>
          </div>
        </div>
        <div class="modeitem">
          <img src="@/assets/xvpay.png" alt="">
          <div class="moderight">
            <div class="paytitle">
              微信 扫码支付
            </div>
            <div class="payinfo">使用微信支付</div>
          </div>
        </div>
        <div class="modeitem">
          <img src="@/assets/bank.png" alt="">
          <div class="moderight">
            <div class="paytitle">
              银行 转账支付
            </div>
            <div class="payinfo">使用银行转账支付</div>
          </div>
        </div>
      </div> -->
      <div class="xieyi">
        <el-checkbox v-model="xieyiflag"></el-checkbox>
        <span class="xieyitxt">
          我已阅读并同意 <span @click="readxieyi">《工资条服务协议》</span>
        </span>
      </div>
      <div class="paybtn" @click="upgradepayment">确认支付</div>
      <!-- <div class="paybtn" @click="payment" v-else>立即支付</div> -->
    </div>

    <!-- 用户协议 -->
    <el-dialog :visible.sync="checkVisible" :close-on-click-modal="false">
      <div class="reg-text" v-html="content"></div>
      <div style="text-align: center; margin-top: 20px">
        <el-button round @click="onArgeen" style="width: 350px" type="primary"
          >同 意</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  packagesalary,
  createorder,
  getPreferentialList,
  upgradepackage,
} from "@/api/setUp.js";

export default {
  props: ["isupgrade", "checkedpackage", "upgradeinfo", "content"],
  created() {
    // this.getpackage()
    this.packagename = this.checkedpackage;
    this.getcurrentinfo();
  },
  data() {
    return {
      currentinfo: [],
      currentindex: 0,
      packagename: "", //选择套餐的名称
      mergepackage: [], //套餐按名称合并之后的集合
      checkpackage: [], //按套餐名称检索之后的集合
      person: "", //选择适用人数 所对应具体的套餐id
      packageinfo: [],
      Discountlist: [],
      num: 1,
      xieyiflag: true,
      checkVisible: false,
    };
  },
  methods: {
    readxieyi() {
      this.checkVisible = true;
    },
    onArgeen() {
      this.xieyiflag = true;
      this.checkVisible = false;
    },
    // 升级优化
    async getcurrentinfo() {
      let { data } = await packagesalary({ app: "salary" });
      let checked = data.filter((item, index) => {
        return item.id == this.upgradeinfo.packageId;
      });
      // 找到当前套餐的级别
      data.forEach((item, index) => {
        if (item.id == this.upgradeinfo.packageId) {
          this.currentindex = item.sequence;
          console.log(this.currentindex);
        }
      });

      this.currentinfo = checked[0]; //当前套餐信息
      this.getpackagelist();
    },

    // 获取所有套餐并且合并
    async getpackagelist() {
      let { data } = await packagesalary({ app: "salary" });

      // data = data.slice(this.currentindex + 1)
      let seqdata = [];
      data.forEach((item) => {
        if (item.sequence > this.currentindex) seqdata.push(item);
      });
      data = seqdata;

      // 获取所有套餐名称
      let packagename = [];
      data.forEach((item) => {
        packagename.push(item.packageName);
      });
      packagename = Array.from(new Set(packagename)); //套餐名称去重
      // packagename = packagename.slice(0, -1)//去除最后一个私有定制版

      // 根据套餐名称将相同名称的套餐合并
      let mergepackage = [];
      packagename.forEach((item1) => {
        let packageitem = [];
        data.forEach((item) => {
          if (item.packageName == item1) {
            packageitem.push(item);
          }
        });
        mergepackage.push(packageitem);
      });
      this.mergepackage = mergepackage;
      this.packagename = this.mergepackage[0][0].packageName; //默认选择第一个套餐
      this.packagechange();
    },

    // 购买套餐 选择套餐
    packagechange(val) {
      if (val == "私有定制") {
        this.$emit("dialogclose", true);
        return 0;
      }
      let checked = this.mergepackage.filter((item) => {
        return item[0].packageName == this.packagename;
      });
      this.checkpackage = checked[0];
      this.person = this.checkpackage[0].id;
      this.personchange();
    },
    personchange(val) {
      let checked = this.checkpackage.filter((item) => {
        return item.id == this.person;
      });
      this.packageinfo = checked[0];
    },

    calculateMonthsDifference(endDateStr) {
      // 将字符串转换为Date对象
      const startDate = new Date();
      const endDate = new Date(endDateStr);

      // 确保endDate在startDate之后
      if (endDate < startDate) {
        throw new Error("结束日期必须在开始日期之后");
      }

      // 计算年份差异
      const yearDiff = endDate.getFullYear() - startDate.getFullYear();

      // 计算月份差异
      const monthDiff = endDate.getMonth() - startDate.getMonth();

      // 如果月份差异是负数（即结束日期的月份小于开始日期的月份），则需要从年份差异中借位
      if (monthDiff < 0) {
        return yearDiff * 12 + monthDiff;
      }

      // 如果月份差异是正数或零，则直接加上年份差异的月份
      return yearDiff * 12 + monthDiff;
    },
    // 剩余月份
    changeMonth(begin) {
      let begintime = new Date(begin);
      let beginstring = begin;
      let nowtime = new Date().valueOf();
      let num = 0;
      while (beginstring < nowtime) {
        begintime.setMonth(begintime.getMonth() + 1);
        var y = begintime.getFullYear();
        var m = begintime.getMonth() + 1;
        var d = begintime.getDate();
        var formatwdate = y + "-" + m + "-" + d;
        beginstring = new Date(formatwdate).valueOf();
        num++;
      }
      return 12 - num;
    },
    async upgradepayment() {
      if (this.xieyiflag) {
        let orderNum = this.calculateMonthsDifference(this.upgradeinfo.end);
        let person = `${this.packageinfo.lowerLimit}-${this.packageinfo.upperLimit}`;
        let num = Math.ceil(
          (this.packageinfo.num / 12) *
            this.calculateMonthsDifference(this.upgradeinfo.end)
        );
        let totle = (
          ((this.packageinfo.price * this.packageinfo.preferentialPrice) / 12) *
          this.calculateMonthsDifference(this.upgradeinfo.end)
        ).toFixed(2);
        let addnum = Math.ceil(
          (this.packageinfo.num / 12) *
            this.calculateMonthsDifference(this.upgradeinfo.end)
        );
        let info = {
          packageId: this.packageinfo.id,
          payAmount: totle,
          buyNum: addnum * 1,
          orderNum: orderNum,
        };
        let { data } = await upgradepackage(info);
        if (data.code == 200) {
          this.$router.push(
            `/index/chosePayment?total=${totle}&orderNum=${data.data}&name=${this.packagename}&person=${person}&num=${num}`
          );
        } else {
          this.$message({
            type: "warning",
            message: data.msg,
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "请先同意购买须知",
        });
      }
    },
    back() {
      this.$emit("itemclick", 1);
    },
  },
  watch: {
    packagename: {
      handler(newVal, oldVal) {
        if (newVal == "私有定制") {
          this.packagename = oldVal;
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  padding: 17px;
  .mian-top {
    height: 57px;
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: left;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2c2d3a;
    line-height: 22px;
    padding-left: 14px;
    div {
      cursor: pointer;
    }
  }
  .mian-bottom {
    height: calc(82vh - 57px);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 18px;
    padding: 18px;
    .bottitle {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2c2d3a;
      line-height: 28px;
      margin-bottom: 16px;
      margin-top: 28px;
    }
    .table {
      height: 56px;
      background: rgba(59, 196, 146, 0.1);
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .props {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 550;
        color: rgba(0, 0, 0, 0.7);
        line-height: 20px;
        width: 20%;
        text-align: center;
      }
    }
    .tableitem {
      height: 56px;
      margin: 0 auto;
      background: #ffffff;
      box-shadow: inset 0px -1px 0px 0px #dfe5eb;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .props {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #2c2d3a;
        line-height: 20px;
        width: 20%;
        text-align: center;
      }
    }
    .buymode {
      width: 55%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .modeitem {
        width: 224px;
        height: 56px;
        background: rgba(83, 203, 159, 0);
        border-radius: 4px;
        border: 1px solid #e0eaf1;
        display: flex;
        align-items: center;
        justify-content: left;
        img {
          height: 40px;
          width: 40px;
          margin: 0 8px;
        }

        .moderight {
          .paytitle {
            font-size: 10px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #2c2d3a;
            line-height: 14px;
          }
          .payinfo {
            font-size: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #838f99;
            line-height: 11px;
          }
        }
      }
    }
    .xieyi {
      margin: 35px 0 25px 0;
    }
    .paybtn {
      width: 148px;
      height: 36px;
      background: #3bc492;
      border-radius: 20px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.xieyitxt {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6f7276;
  line-height: 20px;
  span {
    color: #2f7ff8;
    cursor: pointer;
  }
}
.reg-text {
  height: 60vh;
  overflow: auto;
}
</style>
